import verifyEmailModule from '../verifyEmailModule.js';
import { EnvironmentUrls } from "Roblox";

function verifyEmailService($q, $window, httpService, urlService, verifyEmailResources) {
    "ngInject";

    var verifyEmailService = {
        verifyEmail: function (params) {
            var urlConfig = {
                url: EnvironmentUrls.accountInformationApi + verifyEmailResources.urls.verifyEmailApi
            };
            return httpService.httpPost(urlConfig, params, true);
        }
    }
    return verifyEmailService;
}

verifyEmailModule.factory("verifyEmailService", verifyEmailService);

export default verifyEmailService;